<template>
	<div class="step3-specs">
		<div
			v-for="(spec, name, index) in specs"
			:key="`${name}-${index}`"
			class="step3-specs__component"
		>
			<promo-sales-timed>
				<template v-slot:originalContent>
					<h5 class="step3-specs__component__label">
						{{ name }}:
					</h5>
					<p class="step3-specs__component__name" v-html="spec" />
				</template>
				<template slot-scope="{ phasesInfo: { currentPhase } }">
					<template v-if="(currentPhase == 0 || currentPhase == 1)">
						<h5 class="step3-specs__component__label">
							{{ name }}:
						</h5>
						<div class="specs-tag">
							<p class="step3-specs__component__name" v-html="spec" />
							<holiday-tag :build="buildSpecs" v-if="name == 'case'" />
						</div>
					</template>
					<template/>
				</template>
			</promo-sales-timed>
		</div>
	</div>
</template>

<script>
import { isMobile } from "@u/helpers";
import { getStep3RamText } from "@u/store-helpers";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidayTag from "@c/generals/holiday-tag";

export default {
	name: "Step3BuildSpecs",
	components: {
		PromoSalesTimed,
		HolidayTag
	},
	props: {
		buildSpecs: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			showSpecs: isMobile(true) && window.matchMedia("(orientation: portrait)").matches
		};
	},
	computed: {
		specs() {
			const properties = {
				case: this.buildSpecs.cases,
				cpu: this.buildSpecs.cpus,
				gpu: this.buildSpecs.gpus,
				motherboards: this.buildSpecs.motherboards,
				ram: getStep3RamText(this.buildSpecs.ram)
			};

			if (this.showSpecs) {
				properties["cpu cooling"] = this.buildSpecs.coolers;
				properties.ssd = this.buildSpecs.storage;
				properties.power = this.buildSpecs.psus;
				properties.software = this.buildSpecs.softwares;
			} else {
				properties.storage = this.buildSpecs.storage;
			}

			if (this.buildSpecs.extras && this.buildSpecs.extras.length !== 0 && this.showSpecs) {
				properties.accessories = this.buildSpecs.extras;
			}

			return properties;
		}
	},
	mounted() {
		window.addEventListener("orientationchange", () => {
			this.showSpecs = Math.abs(window.orientation) !== 90;
		});
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.step3-specs {
    &__component {
        margin-bottom: 25px;

        &__label {
            color: $white;
            font-size: 18px;
            text-transform: uppercase;
            margin: 0;

            @media (max-width: 580px) {
                font-size: 14px;
                margin-bottom: 5px;
            }
        }

        &__name {
            opacity: 0.9;
            color: $white;
            font-family: Akkurat-Light;
            font-size: 16px;
            font-weight: 300;

            @media (max-width: 580px) {
                font-size: 14px;
            }
        }
    }
}

.specs-tag::v-deep {
	display: flex;

	.tag {
		margin-left: 4px;
		margin-top: -2px;
		padding: 2px 8px;
	}
}
</style>
